import { Component, Input, TemplateRef, ViewChild } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

// interfaces
import { ModalConfig } from "../modal.interfaces";

@Component({
  selector: "app-general-empty-modal",
  templateUrl: "./general-empty-modal.component.html",
  styleUrls: ["./general-empty-modal.component.css"],
})
export class GeneralEmptyModalComponent {
  @Input() public modalConfig: ModalConfig = { modalTitle: "" };
  private modalRef!: NgbModalRef;
  @ViewChild("content") content!: TemplateRef<any>;

  constructor(private modalService: NgbModal) {}

  open(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.modalRef = this.modalService.open(
        this.content,
        this.modalConfig.ngModalOptions
      );
      this.modalRef.result.then(resolve, resolve);
    });
  }

  async close(): Promise<void> {
    if (
      this.modalConfig.shouldClose === undefined ||
      (await this.modalConfig.shouldClose())
    ) {
      const result =
        this.modalConfig.onClose === undefined ||
        (await this.modalConfig.onClose());
      this.modalRef.close(result);
    }
  }

  async dismiss(): Promise<void> {
    if (
      this.modalConfig.shouldDismiss === undefined ||
      (await this.modalConfig.shouldDismiss())
    ) {
      const result =
        this.modalConfig.onDismiss === undefined ||
        (await this.modalConfig.onDismiss());
      this.modalRef.dismiss(result);
    }
  }
}
